/**
 * CẤU HÌNH MÃ BĂM BẢO MẬT (SHA-256 HASH) ĐƯỢC TỰ ĐỘNG ĐỒNG BỘ TỪ BUILD.JS
 * 
 * Lưu ý: File này chỉ chứa chuỗi mã băm một chiều SHA-256.
 * Tuyệt đối KHÔNG chứa mã bí mật gốc, đảm bảo an toàn 100% khi đẩy mã nguồn lên môi trường công khai.
 */
export const ADMIN_SHA256_HASH = '8206b737a9c48f510804f81d48c8ee9eeacf728ae199dde25bf627d187a9ef58';
